import { axiosSwagger } from "@/axios";
// import Vue from 'vue';

export const state = {
  folder: {
    loading: false, // para sa tree ui
    loadingChildFolders: false, // para ni sa display lang

    // mao ni sa display sa default folders
    data: {
      id: 0,
      name: "My Office",
      description: "",
      childFolders: [], // folders
      fileManagers: [], // files
      parentId: null,
    },

    // tree ui
    loadingTree: false,
    treeData: {
      id: 0,
      name: "My Office",
      description: "",
      childFolders: [], // folders
      fileManagers: [], // files
      parentId: null,
    },

    // selected folder sa tree ui
    selectedData: {},
  },
  // mao ni ma display sa child folders ug files sa pag click sa tree ui folder
  currentChildFolder: {
    loading: false,
    data: [],

    selectedID: null,

    isMultiple: false,
    multipleSelectedID: [],
  },
  pagination: {
    grid: {
      start: 0,
      limit: 0,
    },
    table: {
      start: 0,
      limit: -1,
    }
  },
  // for pin changes
  pin: {
    data: {},
  }
}


export const getters = {
}


export const mutations = {
  // FOLDER
  folderLoading: (state, loading) => {
    state.folder.loading = loading;
  },
  childFolderLoading: (state, loading) => {
    state.folder.loadingChildFolders = loading;
  },
  setFolderData: (state, data) => {
    state.folder.data.childFolders = modifyData( data );

    // manipulate the response: add depth folder of data using recursive function
    // breadcrumbs = [];
    // treeCountIndex = 0;

    // traverse( JSON.parse(JSON.stringify(state.folder.data)) );
    // state.folder.data = modifiedTreeData(JSON.parse(JSON.stringify(state.folder.data)));
  },
  setTreeFolderData: (state, data) => {
    state.folder.treeData.childFolders = modifyData2( data );
  },
  setTreefolderLoading: (state, loading) => {
    state.folder.loadingTree = loading;
  },
  selectFolder: (state, data) => {
    state.folder.selectedData = data;
  },
  // CURRENT FOLDER
  currentChildFolderLoading: (state, loading) => {
    state.currentChildFolder.loading = loading;
  },
  setCurrentChildFolderData: (state, data) => {
    state.currentChildFolder.data = modifyData( data );
  },
  removeFolder: (state, id) => {
    state.currentChildFolder.data = state.currentChildFolder.data.filter(
      (el) => el.id !== id
    );
  },
  selectFolderID: (state, id) => {
    // remove ang file selected id
    // state.currentChildFile.selectedID = null;

    // set ang folder selected id
    state.currentChildFolder.selectedID = id;
  },
  updatePinFolder: (state, data) => {
    let folderData = data.isMyFolderPage ? state.folder.data.childFolders : state.currentChildFolder.data;
    
    const index = folderData.findIndex((item) => item.id === data.id);

    if (index !== -1) {
        folderData[index].isPinned = !folderData[index].isPinned;
        
        // update pin data for changes sa ui lang sa file-maanger (default)
        state.pin.data = data;
    }
  },
  // update ang folder sa folder data
  updateMoveFolderToFolder: (state, { folder, destinationFolder }) => {
    let isMyFolderPage = folder.parentId === null ? true : false;

    // state.folder.data.childFolders
    if(isMyFolderPage){
      // remove ang ge move na folder
      state.folder.data.childFolders = state.folder.data.childFolders.filter(
        (el) => el.id !== folder.id
      );

      // update ang destination folder data
      const index = state.folder.data.childFolders.findIndex((item) => item.id === destinationFolder.id);

      if (index !== -1) {
        state.folder.data.childFolders[index].childFolders.push(folder);
        state.folder.data.childFolders[index].childCount += 1;
      }

    }
    // state.currentChildFolder.data
    else{
      // remove ang ge move na folder
      state.currentChildFolder.data = state.currentChildFolder.data.filter(
        (el) => el.id !== folder.id
      );
      
      // update ang destination folder data
      const index = state.currentChildFolder.data.findIndex((item) => item.id === destinationFolder.id);

      if (index !== -1) {
        state.currentChildFolder.data[index].childFolders.push(folder);
        state.currentChildFolder.data[index].childCount += 1;
      }
    }
  },
  // update ang fileManagers sa folder data
  updateMoveFileToFolder: (state, { file, folder }) => {
    const index = state.currentChildFolder.data.findIndex((item) => item.id === folder.id);

    if (index !== -1) {
      state.currentChildFolder.data[index].fileManagers.push(file);
      state.currentChildFolder.data[index].totalFileSize += file.totalFileSize;
    }
  },
  // multiple
  setIsMultiple: (state, boolean) => {
    state.currentChildFolder.isMultiple = boolean;
  },
  setSingleMultipleID: (state, id) => {
    state.currentChildFolder.multipleSelectedID = [id];
  },
  selectMultipleID: (state, id) => {
    // toggle multiple select
    if(!state.currentChildFolder.multipleSelectedID?.includes(id)){
      state.currentChildFolder.multipleSelectedID.push(id);
    }
    else{
      state.currentChildFolder.multipleSelectedID = state.currentChildFolder.multipleSelectedID.filter(
        (el) => el !== id
      );
    }
  },
  // eslint-disable-next-line no-unused-vars
  removeAllMultipleSelectID: (state, data) => {
    state.currentChildFolder.multipleSelectedID = [];
  },
  setAllMultipleSelectID: (state, data) => {
    if(data?.length ?? false){
      data.forEach(e => {
        if(!state.currentChildFolder.multipleSelectedID?.includes(e.id)){
          state.currentChildFolder.multipleSelectedID.push(e.id);
        }
      });
    }
  },
  removeSelectedMultipleSelectID: (state, data) => {
    if(data?.length ?? false){
      let _arrIds = data.map(e => e.id);
      
      state.currentChildFolder.multipleSelectedID = state.currentChildFolder.multipleSelectedID.filter(
        (el) => !_arrIds.includes(el)
      );
    }
  },
  // pagination GRID
  setPaginationGridStart: (state, data) => {
    state.pagination.grid.start = data;
  },
  setPaginationGridLimit: (state, data) => {
    state.pagination.grid.limit = data;
  },
  // pagination TABLE
  setPaginationTableStart: (state, data) => {
    state.pagination.table.start = data;
  },
  setPaginationTableLimit: (state, data) => {
    state.pagination.table.limit = data;
  },
  removeMultipleFolder: (state, dataArr) => {
    if(state.folder.data.childFolders?.length){
      state.folder.data.childFolders = state.folder.data.childFolders.filter(
        (el) => !dataArr?.includes(el.id)
      );
    }
    
    if(state.currentChildFolder.data?.length){
      state.currentChildFolder.data = state.currentChildFolder.data.filter(
        (el) => !dataArr?.includes(el.id)
      );
    } 
  },
  updateMoveMultipleFolderToFolder: (state, { folderIds, destinationFolder }) => {
    let isMyFolderPage = destinationFolder.parentId === null ? true : false;

    // state.folder.data.childFolders
    if(isMyFolderPage){
      // remove ang ge move na folder
      state.folder.data.childFolders = state.folder.data.childFolders.filter(
        (el) => !folderIds?.includes(el.id)
      );

      // update ang destination folder data
      const index = state.folder.data.childFolders.findIndex((item) => item.id === destinationFolder.id);

      if (index !== -1) {
        // state.folder.data.childFolders[index].childFolders = state.folder.data[index].childFolders.concat(folders);
        state.folder.data.childFolders[index].childCount += (folderIds?.length || 0);
      }

    }
    // state.currentChildFolder.data
    else{
      // remove ang ge move na folder
      state.currentChildFolder.data = state.currentChildFolder.data.filter(
        (el) => !folderIds?.includes(el.id)
      );
      
      // update ang destination folder data
      const index = state.currentChildFolder.data.findIndex((item) => item.id === destinationFolder.id);
  
      if (index !== -1) {
        // state.currentChildFolder.data[index].childFolders = state.currentChildFolder.data[index].childFolders.concat(folders);
        state.currentChildFolder.data[index].childCount += (folderIds?.length || 0);
      }
    }
  },
  updateMoveMultipleFileToFolder: (state, { files, folder }) => {
    const index = state.currentChildFolder.data.findIndex((item) => item.id === folder.id);

    if (index !== -1 && files) {
      state.currentChildFolder.data[index].fileManagers = state.currentChildFolder.data[index].fileManagers.concat(files);
      state.currentChildFolder.data[index].totalFileSize += sum(files, 'totalFileSize');
    }
  },
}


export const actions = {
  // FOLDER
  async readFolder({ commit }, isLoad) {
    isLoad ? commit("childFolderLoading", true) : "";

    const userData = localStorage.getItem("USER") !== null && localStorage.getItem("USER") !== '' ? JSON.parse(localStorage.getItem("USER")) : null;

    return await axiosSwagger
      .get(`/api/FileFolder/My/${userData?.deliveryUnit?.id}`)
      .then((response) => {
        commit("setFolderData", response.data);
        isLoad ? commit("childFolderLoading", false) : "";

        return response;
      })
      .catch(() => {
        isLoad ? commit("childFolderLoading", false) : "";
      });
  },
  // TREE FOLDER
  async readTreeFolder({ commit }, parentId) {
    commit("setTreefolderLoading", true);

    const userData = localStorage.getItem("USER") !== null && localStorage.getItem("USER") !== '' ? JSON.parse(localStorage.getItem("USER")) : null;

    return await axiosSwagger
      .get(`/api/FileFolder/Simple/My/${parentId}/${userData?.deliveryUnit?.id}`)
      .then((response) => {
        if(parentId === 0){
          commit("setTreeFolderData", response.data);
        }
        commit("setTreefolderLoading", false);

        return response;
      })
      .catch(() => {
        commit("setTreefolderLoading", false);
      });
  },
  // kay same end-point man magamit sa 2 ka component (tree ug sa display folders)
  async readTreeFolderByParentId({ commit }, id) {
    commit("folderLoading", true);

    const userData = localStorage.getItem("USER") !== null && localStorage.getItem("USER") !== '' ? JSON.parse(localStorage.getItem("USER")) : null;

    return await axiosSwagger
      .get(`/api/FileFolder/Child/${id}/${userData?.deliveryUnit?.id}`)
      .then((response) => {
        commit("folderLoading", false);

        return response;
      })
      .catch(() => {
        commit("folderLoading", false);
      });
  },
  async readFolderByParentId({ commit }, obj) {
    obj.isLoad ? commit("currentChildFolderLoading", true) : "";

    const userData = localStorage.getItem("USER") !== null && localStorage.getItem("USER") !== '' ? JSON.parse(localStorage.getItem("USER")) : null;

    return await axiosSwagger
      .get(`/api/FileFolder/Child/${obj.id}/${userData?.deliveryUnit?.id}`)
      .then((response) => {
        commit("setCurrentChildFolderData", response.data);
        obj.isLoad ? commit("currentChildFolderLoading", false) : "";

        return response;
      })
      .catch(() => {
          obj.isLoad ? commit("currentChildFolderLoading", false) : "";
      });
  },
  // eslint-disable-next-line no-unused-vars
  async createFolder({ commit }, data) {
    const userData = localStorage.getItem("USER") !== null && localStorage.getItem("USER") !== '' ? JSON.parse(localStorage.getItem("USER")) : null;

    return await axiosSwagger
      .post(`/api/FileFolder/Create/${userData?.deliveryUnit?.id}`, data)
      .then((response) => {
        // commit('addFolder', response.data);
        return response;
      });
  },
  // eslint-disable-next-line no-unused-vars
  async multipleCreateFolder({ commit }, data) {
    const userData = localStorage.getItem("USER") !== null && localStorage.getItem("USER") !== '' ? JSON.parse(localStorage.getItem("USER")) : null;
    
    return await axiosSwagger
      .post(`/api/FileFolder/Create/Multiple/${userData?.deliveryUnit?.id}`, data)
      .then((response) => {
        // commit('addFolder', response.data);
        return response;
      });
  },
  // POST TRASH FOLDER
  async trashFolder({ commit }, id) {
    return await axiosSwagger
      .post(`/api/FileFolder/Trash`, [{ id }])
      .then((response) => {
        commit("removeFolder", id);
        return response;
    });
  },
  async multipleTrashFolder({ commit }, data) {
    return await axiosSwagger
    .post(`/api/FileFolder/Trash`, data)
    .then((response) => {
        commit("removeMultipleFolder", data.map(e => e.id));

        return response;
    });
  },
  // eslint-disable-next-line no-unused-vars
  async updateFolder({ commit }, data) {
    return await axiosSwagger
      .put(`/api/FileFolder/Update/${data.id}`, data)
      .then((response) => {
        return response;
    });
  },
  // UPDATE PIN FOLDER
  async updatePinFolder({ commit }, data) {
    return await axiosSwagger
      .put(`/api/FileFolder/Pin/${data.id}`)
      .then((response) => {
        commit('updatePinFolder', data);
        return response;
      });
  },
  // UPDATE UNPIN FOLDER
  async updateUnPinFolder({ commit }, data) {
    return await axiosSwagger
      .put(`/api/FileFolder/UnPin/${data.id}`)
      .then((response) => {
        commit('updatePinFolder', data);
        return response;
      });
  },
}


// modify data for totalFileSize
const modifyData = (arrayData) => {
  if(arrayData?.length ?? false){
    arrayData.forEach(e => {
      e.totalFileSize = (e.fileManagers?.length ?? false) ? sum(e.fileManagers, 'totalFileSize') : 0;
    });

    return arrayData;
  }

  return [];
};

// modify data for childFolders
const modifyData2 = (arrayData) => {
  if(arrayData?.length ?? false){
    arrayData.forEach(e => {
      e.childFolders = [];
    });

    return arrayData;
  }

  return [];
};

const sum = (array, key) => {
  if (!Array.isArray(array) || array.length === 0) {
    return 0;
  }

  return array.reduce((accumulator, object) => {
    return accumulator + object[key];
  }, 0);
}


// // get breadcrumbs
// var breadcrumbs = [];
// function traverse(node, path) {
//   if ( !path ){
//     path = [];
//   }

//   if (node.name) {

//     if(path.length > 0){
//       let encryptId = Vue.prototype.$encryptRouteID(node.id.toString());
  
//       path.push({
//         id: node.id,
//         text: node.name.toString(),
//         to: { name: "Folder ID", params: { id: encryptId } },
//       })
//     }
//     else{
//       path.push({
//         id: 0,
//         text: "My Folder",
//         to: { name: "My Folder" },
//       })
//     }
    
//   }
//   breadcrumbs.push(path);

//   if (node.childFolders) {
//     node.childFolders.forEach(function(item) {
//       traverse(item, path.slice());
//     });
//   }
// }

// var treeCountIndex = 0;
// const modifiedTreeData = (treeData, depth = 0) => {
//   treeData.depth = depth;

//   // set breadcrumbs
//   if(treeData.breadcrumbs === undefined){
//     treeData.breadcrumbs = breadcrumbs[treeCountIndex];
//   }
//   treeCountIndex = treeCountIndex+1;

//   // if naay child folders
//   if (treeData.childFolders && treeData.childFolders.length) {
//     treeData.childFolders.forEach((childFolder) => {
//       modifiedTreeData(childFolder, depth + 1);
//     });
//   }

//   return treeData;
// };